// the named export: the package is CommonJS, so a default import gets its whole exports object
import { Intercom, boot, update, trackEvent } from '@intercom/messenger-js-sdk';

const INTERCOM_APP_ID = 'l7dj1k9h';

Intercom({ app_id: INTERCOM_APP_ID });

export function intercomBoot({
  userId,
  email,
  name,
  externalId,
  userHash
}: {
  userId: string;
  email: string;
  name: string;
  externalId?: string;
  userHash?: string;
}) {
  boot({
    app_id: INTERCOM_APP_ID,
    user_id: userId,
    email,
    name,
    external_id: externalId,
    user_hash: userHash
  });
}

export function intercomUpdate() {
  update({});
}

export function intercomTrackEvent(event: string, metadata?: object) {
  trackEvent(event, metadata);
}
